import React, { useEffect, useState } from 'react'
import MergeTableContainer from './container';

const MergeTableDialog = ({open, onClose, parentTable, tables, onMerge }) => {
  const [selectedTableIds, setSelectedTableIds] = useState([]);
  const [totalCapacity, setTotalCapacity] = useState(parentTable?.capacity || 0);

  // Reset state on open/close
  useEffect(() => {
    if (open) {
      setSelectedTableIds([]);
      setTotalCapacity(parentTable?.capacity || 0);
    }
  }, [open, parentTable]);

  const handleCheckboxChange = (table) => {
    let updatedSelected;

    if (selectedTableIds.includes(table.id)) {
      updatedSelected = selectedTableIds.filter((id) => id !== table.id);
    } else {
      updatedSelected = [...selectedTableIds, table.id];
    }
    setSelectedTableIds(updatedSelected);

    // Calculate capacity dynamically
    const selectedCapacity = tables
      .filter((t) => updatedSelected.includes(t.id))
      .reduce((sum, t) => sum + t.capacity, 0);

    setTotalCapacity((parentTable?.capacity || 0) + selectedCapacity);
  };

  const handleMergeClick = () => {
    if (selectedTableIds.length > 0) {
      onMerge({
        parent_id: parentTable?.id,
        child_ids: selectedTableIds
      });
    }
  };

  // Filter only available tables excluding parent
  const availableTables = tables?.filter(
    (t) => t.id !== parentTable?.id && t.status === "available" && t.merged !== true
  );

  return (
    <MergeTableContainer
        open={open}
        onClose={onClose}
        handleCheckboxChange={handleCheckboxChange}
        parentTable={parentTable}
        availableTables={availableTables}
        handleMergeClick={handleMergeClick}
        totalCapacity={totalCapacity}
        selectedTableIds={selectedTableIds}
    />
  )
}

export default MergeTableDialog;